import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, credentials);
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminUser", response.data.username);
      toast.success("Login successful!");
      navigate("/admin");
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="glass-effect p-10 rounded-2xl max-w-md w-full mx-4" data-testid="admin-login-form">
        <div className="text-center mb-8">
          <h1 className="font-heading text-4xl font-bold text-text-primary mb-2">Admin Login</h1>
          <p className="text-text-secondary">Star Nivesh CMS</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-text-primary mb-2">Username</label>
            <Input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              required
              data-testid="admin-username-input"
            />
          </div>
          <div>
            <label className="block text-text-primary mb-2">Password</label>
            <Input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              required
              data-testid="admin-password-input"
            />
          </div>
          <Button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-button">
            <LogIn className="mr-2 h-5 w-5" />
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
      </div>
    </div>
  );
}